import { createSlice } from "@reduxjs/toolkit";
import {
  getEngineCashFlowResult,
  getEngineIndividualCashflowParam,
  updateEngineCashFlow,
} from "./engineCashFlowAction";
import { deleteCashflowParams } from "../aircraft/cashFlowActions";
import { first } from "lodash";

export const initialState = {
  isInitialLoad: true,
  loading: false,
  addLoading: false,
  engineCashflowResult: {},
  assetIntialLoad: true,
  assets: {},
  addAssetLoading: false,
  paramsLoader: false,
  selectedEngineCashflowParams: {},
  engineEndividualCashflowParam: [],
};

const engineCashflow = createSlice({
  name: "cashflow",
  initialState,
  reducers: {
    setInitialLoad: (state, action) => {
      state.isInitialLoad = action.payload;
    },
    setAssetInitialLoad: (state, action) => {
      state.assetIntialLoad = action.payload;
    },
    setSelectedEngineCashflowParams: (state, action) => {
      state.selectedEngineCashflowParams = action.payload;
    },
    clearProjectData: (state) => {
      state.initialState = true;
      state.loading = false;
      state.addLoading = false;
      state.engineCashflowResult = {};
      state.assetIntialLoad = true;
      state.assets = {};
      state.addAssetLoading = false;
      state.paramsLoader = false;
    },
    refreshEngineCashflow: (state) => {
      state.initialState = true;
      state.loading = false;
      state.addLoading = false;
      state.engineCashflowResult = {};
      state.paramsLoader = false;
      state.selectedEngineCashflowParams = {};
      state.engineEndividualCashflowParam = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Engine cash flow Result
      .addCase(getEngineCashFlowResult.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineCashFlowResult.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.engineCashflowResult = action.payload?.data;
      })
      .addCase(getEngineCashFlowResult.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.cashflowResult = {};
      })

      // get cash flow INDIVIDUAL CASHFLOW PARAM
      .addCase(getEngineIndividualCashflowParam.pending, (state) => {
        state.loading = true;
        state.selectedEngineCashflowParams = {};
        state.engineEndividualCashflowParam = [];
      })
      .addCase(getEngineIndividualCashflowParam.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        const data = action.payload?.data;
        state.engineEndividualCashflowParam = data
          ? Array.isArray(data)
            ? data
            : [data]
          : {};
        state.selectedEngineCashflowParams = data
          ? Array.isArray(data)
            ? first(data)
            : data
          : {};
      })
      .addCase(getEngineIndividualCashflowParam.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.engineEndividualCashflowParam = [];
      })

      // update cash Flow
      .addCase(updateEngineCashFlow.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateEngineCashFlow.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(updateEngineCashFlow.rejected, (state, action) => {
        state.addLoading = false;
      })

      // delete cashflow params
      .addCase(deleteCashflowParams.pending, (state) => {
        state.paramsLoader = true;
      })
      .addCase(deleteCashflowParams.fulfilled, (state, action) => {
        state.paramsLoader = false;
      })
      .addCase(deleteCashflowParams.rejected, (state, action) => {
        state.paramsLoader = false;
      });
  },
});

export const {
  setInitialLoad,
  setRoleInitalLoad,
  setAssetInitialLoad,
  clearProjectData,
  refreshEngineCashflow,
  setSelectedEngineCashflowParams,
} = engineCashflow.actions;
export default engineCashflow.reducer;
